import dates from '@/assets/js/dates'

export const uploadedAt = {
  label: 'Uploaded At',
  key: 'uploaded_at',
  icon: 'calendar-outline',
  tooltip: 'Limit results based on when the return was uploaded.',
  options: dates
}
